export const keyPrefix = 'PRINT_DEFINITIONS';
export const setPrintDefsLocalStorage = (procName: string, data) => {
    localStorage.setItem(`${keyPrefix}_${procName}`, JSON.stringify(data));
};

export const getUserChoicesLocalStorage = (procName: string) => {
    const dataString = localStorage.getItem(`${keyPrefix}_${procName}`) || '{}';
    return JSON.parse(dataString);
};
